import React from 'react';
import { motion } from 'framer-motion';
import Contact from '../components/Contact';

const FAQContent = () => {
  const [openIndex, setOpenIndex] = React.useState<number | null>(null);
  const faqs = [
    {
      question: "What makes Advance Elegance Studio unique?",
      answer: "We combine artistic vision with technical excellence to create timeless imagery. Our approach focuses on luxury aesthetics, attention to detail, and personalized service for each client."
    },
    {
      question: "Do you offer international photography services?",
      answer: "Yes, we provide photography services worldwide for select clients. Our team is experienced in international projects and can accommodate travel requirements for your specific needs."
    },
    {
      question: "What is your pricing structure?",
      answer: "Our pricing is customized based on project requirements, scope, and specific needs. We offer various packages starting from premium shoots to comprehensive photography solutions. Contact us for a detailed quote."
    },
    {
      question: "How can I book a consultation?",
      answer: "You can schedule a consultation through our website's booking system or contact us directly. We'll arrange a meeting to discuss your vision, requirements, and how we can best serve your needs."
    },
    {
      question: "What is your typical project timeline?",
      answer: "Project timelines vary depending on scope and complexity. Generally, we deliver initial previews within 48 hours and final edited images within 1-2 weeks. Rush delivery is available upon request."
    },
    {
      question: "What equipment do you use?",
      answer: "We use professional-grade equipment including the latest high-end cameras, lighting systems, and post-processing software to ensure the highest quality results for our clients."
    }
  ];
  return (
    <div className="space-y-6">
      {faqs.map((faq, index) => (
        <div
          key={index}
          className="border border-gray-800 rounded-lg overflow-hidden"
        >
          <button
            className="w-full px-6 py-4 flex items-center justify-between text-left"
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
          >
            <span className="text-lg font-semibold text-white">{faq.question}</span>
            {openIndex === index ? (
              <span className="text-emerald-400">-</span>
            ) : (
              <span className="text-emerald-400">+</span>
            )}
          </button>
          {openIndex === index && (
            <div className="px-6 pb-4">
              <p className="text-gray-400">{faq.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

const ContactPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="pt-20"
    >
      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1490481651871-ab68de25d43d?ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80')"
          }}
        >
          <div className="absolute inset-0 bg-black/70"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-7xl font-bold mb-6">Get in Touch</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Let's bring your fashion vision to life. Connect with our design team today.
          </p>
        </div>
      </section>

      <Contact />

      {/* FAQ Section */}
      <section className="w-full py-24 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold mb-10 text-center text-white">Frequently Asked Questions</h2>
          <FAQContent />
        </div>
      </section>
    </motion.div>
  );
};

export default ContactPage; 